var exports = {
  "x6": "GuildListDMItem.module__button___NVRhWF",
  "V8": "GuildListDMItem.module__relative___NVRhWF",
  "PH": "GuildListDMItem.module__fullSize___NVRhWF",
  "SU": "GuildListDMItem.module__muted___NVRhWF",
};

module.exports = exports;
